import React from 'react';

// material-ui
import { Typography } from '@material-ui/core';

// project imports
import { useBackendUserState } from 'contexts/UserContext';
import NavGroup from './NavGroup';
import menuItems from '../../../../menu-items';

// -----------------------|| SIDEBAR MENU LIST ||-----------------------//

const MenuList = () => {
  const { state: { user: backendUser } } = useBackendUserState();
  const isSuperuser = backendUser?.isSuperuser;
  const ccType = backendUser?.clinicCoordinator?.ccType;
  const [filteredMenuItemsRender, setFilteredMenuItemsRender] = React.useState([]);
  React.useEffect(() => {
    const menuItemsLocal = JSON.parse(JSON.stringify(menuItems));

    for (let i = 0; i < menuItemsLocal.items.length; i += 1) {
      if (menuItemsLocal.items[i].children) {
        for (let j = 0; j < menuItemsLocal.items[i].children.length; j += 1) {
          if (menuItemsLocal.items[i].children[j].type === 'collapse') {
            for (let k = 0; k < menuItemsLocal.items[i].children[j].children.length; k += 1) {
              menuItemsLocal.items[i].children[j].children[k].icon = menuItems.items[i].children[j].children[k].icon;
            }
          } else {
            menuItemsLocal.items[i].children[j].icon = menuItems.items[i].children[j].icon;
          }
        }
      }
    }
    let filteredMenuItems = menuItemsLocal.items.filter(item => {
      if (!item.isSuperuser) {
        return true;
      }
      return item.isSuperuser && isSuperuser;
    });
    for (let i = 0; i < filteredMenuItems.length; i += 1) {
      const menuItem = filteredMenuItems[i];
      if (menuItem.children) {
        const children = menuItem.children.filter(child => {
          if (child.isSuperuser) {
            return child.isSuperuser && isSuperuser;
          }

          if (!child.ccTypesAllowed) {
            return true;
          }
          return child.ccTypesAllowed.includes(ccType);
        });
        filteredMenuItems[i].children = children;
      }
    }
    filteredMenuItems = filteredMenuItems.filter(item => {
      if (item.children) {
        return item.children.length > 0;
      }
      return true;
    });
    setFilteredMenuItemsRender(filteredMenuItems);
  }, [isSuperuser, ccType]);
  return filteredMenuItemsRender.map(item => {
    if (item.type === 'group') {
      return <NavGroup key={item.id} item={item} />;
    }

    return (
      <Typography key={item.id} variant="h6" color="error" align="center">
        Menu Items Error
      </Typography>
    );
  });
};

export default MenuList;
